import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

import MapResizeZoom from "components/maps/MapResizeZoom";
import { MarkerIcon } from "components/waste-icons";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';

/**
 * LeafletMapAssetContainer - Leaflet version of MapAssetsContainer.
 */
const LeafletMapAssetContainer = ({ center, waypoints }) => {
    var [_Tc] = useTranslation("choices");
    const ZOOM = 13;
    const [position, setPosition] = useState([...center]);

    useEffect(() => {
        setPosition(center);
    }, [center]);

    return (
        position.length
            ? <MapContainer
                center={position}
                zoom={ZOOM}
                scrollWheelZoom={false}
                style={{ width: '100%', height: '300px', zIndex: '2' }}
            >
                {
                    position.length && position[0] && position[1]
                        ? <MapResizeZoom position={position} zoomDefault={ZOOM} />
                        : <></>
                }

                <TileLayer
                    url={CARTO_TILE_URL}
                    {...CARTO_TILE_OPTIONS}
                />
                {
                    waypoints.length
                        ? waypoints.map((waypoint, idx) =>
                            <React.Fragment key={idx}>
                                <Marker position={[waypoint.lat, waypoint.lng]} icon={MarkerIcon}>
                                    <Popup>
                                        {_Tc("wastes." + waypoint.waste_type)}
                                    </Popup>
                                </Marker>

                                {waypoint.devices && waypoint.devices.map((device, dIdx) => (
                                    <Marker
                                        key={`${idx}-d-${dIdx}`}
                                        position={[device.lat, device.lng]}
                                    >
                                        <Popup>
                                            <b>IMEI:</b> {device.uuid}
                                        </Popup>
                                    </Marker>
                                ))}
                            </React.Fragment>
                        )
                        : <></>
                }

            </MapContainer>
            : <></>

    );
}

export default LeafletMapAssetContainer;
